<template>
  <el-date-picker v-model="defineValue" :placeholder="placeholder" :disabled="disabled" :type="type"
    :value-format="valueFormat" :format="valueFormat" @change="changeValue" />
</template>

<script>
  export default {
    props: {
      placeholder: {
        type: String,
        required: false,
      },
      type: {
        type: String,
        required: false,
        default: () => {
          return 'date'
        }
      },
      valueFormat: {
        type: String,
        required: false,
        default: 'yyyy-MM-dd'
      },
      disabled: {
        type: Boolean,
        required: false,
      },
      // value 有可能是 undefined unll 不定义type
      value: {
        required: true,
      }
    },
    watch:{
       value(val,oldVal) {
          this.defineValue = val
       }
    },
    data() {
      return {
        defineValue: this.value,
      }
    },
    methods: {
      changeValue(e) {
        console.log(this.valueFormat)
        this.defineValue = e
        this.$emit('input', e)
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ABdate.vue